import { render, staticRenderFns } from "./HistoryItemTypeFilial.vue?vue&type=template&id=62b66eb6&scoped=true&"
import script from "./HistoryItemTypeFilial.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypeFilial.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypeFilial.vue?vue&type=style&index=0&id=62b66eb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b66eb6",
  null
  
)

export default component.exports